import { Box, Button, Modal, Typography } from "@mui/material";
import { FC } from "react";

interface Props {
  isDeleting: boolean;
  assignToDeleteSuscr: (id: string) => void;
  handleDelete: () => Promise<void>;
  toDeleteSuscr: string;
  title: string;
  subtitle: string;
}

const DeleteSuscrModal: FC<Props> = ({
  isDeleting,
  assignToDeleteSuscr,
  handleDelete,
  toDeleteSuscr,
  title,
  subtitle
}) => {
  const handleClose = () => {
    if (!isDeleting) {
      assignToDeleteSuscr("");
    }
  };

  return (
    <Modal
      open={Boolean(toDeleteSuscr)}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(0, 0, 0, 0.3)", // Fondo negro con opacidad
      }}
    >
      <Box
        component={"div"}
        sx={{
          width: 400,
          bgcolor: "background.paper", // Fondo blanco del modal
          borderRadius: 2, // Bordes redondeados
          p: 4,
          boxShadow: 24,
          minWidth: "600px",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Typography component={"h3"} sx={{ fontSize: "20px", fontWeight: 600 }}>
          {title}
        </Typography>
        <Typography component={"p"}>
          {subtitle}
        </Typography>
        <Box
          sx={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            gap: 3,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => assignToDeleteSuscr("")}
            disabled={isDeleting}
            sx={{
              borderRadius: 14,
              border: "1px solid #336B87",
              color: "#336B87",
              "&:hover": {
                backgroundColor: "#336B87",
                color: "#EEF3F6",
              },
            }}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            sx={{ background: "#336B87" }}
            disabled={isDeleting}
            onClick={handleDelete}
          >
            Confirmar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteSuscrModal;
